import BaseModel from './BaseModel';

class AccountPspCredential extends BaseModel {}

AccountPspCredential.getListingFields = () => [
    'id',
    'account_id',
    'payment_system_id',
    'label',
    'status',
    'environment',
    'token_expires_at',
    'last_refresh_at',
];

export default AccountPspCredential;
